import React from "react";
import { Service } from "../../types/service";

type Props = {
  service: Service;
  index: number;
};

const ServiceCard = (props: Props) => {
  return (
    <div>
      <div className="group border-b border-white/30 pb-8">
        <div className="flex flex-col gap-4 divide-y divide-white/30">
          <span className="inline-block text-white/60">00{props.index}</span>
          <h3 className="bg-black pt-6 text-3xl text-white">
            {props.service.title}
          </h3>
        </div>
        <div className="mt-0 overflow-hidden transition-all duration-500 group-hover:mt-8">
          <p className="max-h-0 font-light text-white/70 transition-all duration-500 group-hover:max-h-24 md:text-xl">
            {props.service.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
